import { atomWithStorage } from "jotai/utils";
import { initialStateProfile } from "./initialState";

export const profileAtom = atomWithStorage("user", initialStateProfile);
